"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _constants = require("@seedlang/constants");
var _state = require("@seedlang/state");
var _utils = require("@seedlang/utils");
var _video_player_wrapper = require("./video_player_wrapper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var UserInputWrapper = function UserInputWrapper(Component) {
  var _class, _class2, _descriptor, _Class;
  return (0, _mobxReact.observer)(_class = (_class2 = (_Class = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _initializerDefineProperty(_this, "showMicAccessModal", _descriptor, _this);
      _this.pauseOffscreen = function () {
        var store = _this.props.userInputStore;
        if (!store) {
          return;
        }
        if (typeof store.pause === 'function') {
          store.pause();
        }
      };
      _this.onSubmit = function () {
        if ((0, _utils.isPresent)(_this.props.userInputStore) && _this.props.userInputStore.hasMessageInput && _this.props.onSubmitMessage) {
          _this.props.onSubmitMessage(_this.props.userInputStore.messageInput);
          _this.props.userInputStore.onUpdateMessageInput(null);
        } else if (_this.props.onSubmitMedia) {
          _this.props.onSubmitMedia();
          _this.onReset();
        }
      };
      _this.onReset = function () {
        _state.DeckUI.layout.setUserInputExpanded(false);
        _this.props.userInputStore.setInputType(null);
        _this.props.userInputStore.onUpdateMessageInput('');
        _this.props.userInputStore.onMediaReset();
      };
      _this.setInputType = function (inputType) {
        _state.DeckUI.layout.setUserInputExpanded(inputType === 'text');
        _this.props.userInputStore.setInputType(inputType);
        if (inputType === 'text') {
          _state.DeckUI.textRevealed = false;
          _state.DeckUI.currentCardState.revealed = false;
        }
      };
      _this.onKeyUp = function (e) {
        if (e.keyCode === 13 && !e.shiftKey) {
          _this.onSubmit();
        }
      };
      _this.onUpdateMessageInput = function (val) {
        _this.props.userInputStore.onUpdateMessageInput(val);
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "recordingIconBorderColor",
      get: function get() {
        if (this.props.disabled) {
          return _constants.Theme.disabled;
        } else if (!this.props.showTextIcon) {
          return _constants.Theme.darkestBlue;
        }
      }
    }, {
      key: "recordingIconBackground",
      get: function get() {
        if (this.props.disabled) {
          return _state.DeckUI.layout.disabledColor;
        } else if (this.props.showTextIcon) {
          return _constants.Theme.darkestBlue;
        } else {
          return _constants.Theme.red;
        }
      }
    }, {
      key: "iconWidth",
      get: function get() {
        if (this.props.minimumHeight) {
          return 27;
        } else if (this.props.showTextIcon) {
          return 34;
        } else {
          return 30;
        }
      }
    }, {
      key: "disableSendIcon",
      get: function get() {
        return this.props.userInputStore && !this.props.userInputStore.hasFinishedRecording && (0, _utils.isPresent)(this.props.userInputStore) && this.props.userInputStore && !(0, _utils.isPresent)(this.props.userInputStore.messageInput);
      }
    }, {
      key: "textInputDisabled",
      get: function get() {
        var _this$props$userInput, _this$props$userInput2, _this$props$userInput3;
        return this.props.disabled || this.props.userInputStore && (((_this$props$userInput = this.props.userInputStore) === null || _this$props$userInput === void 0 ? void 0 : _this$props$userInput.isRecording) || ((_this$props$userInput2 = this.props.userInputStore) === null || _this$props$userInput2 === void 0 ? void 0 : _this$props$userInput2.hasRecording) || ((_this$props$userInput3 = this.props.userInputStore) === null || _this$props$userInput3 === void 0 ? void 0 : _this$props$userInput3.recordingActiveInput));
      }
    }, {
      key: "videoDisabled",
      get: function get() {
        return this.props.disabled || this.props.userInputStore && this.props.userInputStore.recordingActiveInput;
      }
    }, {
      key: "audioDisabled",
      get: function get() {
        return this.props.disabled || this.props.userInputStore && this.props.userInputStore.videoActiveInput;
      }
    }, {
      key: "videoRecording",
      get: function get() {
        var _this$props$userInput4;
        return this.props.userInputStore && this.props.userInputStore.mediaType === 'video' && ((_this$props$userInput4 = this.props.userInputStore) === null || _this$props$userInput4 === void 0 ? void 0 : _this$props$userInput4.isRecording);
      }
    }, {
      key: "audioRecording",
      get: function get() {
        var _this$props$userInput5;
        return this.props.userInputStore && this.props.userInputStore.mediaType === 'audio' && ((_this$props$userInput5 = this.props.userInputStore) === null || _this$props$userInput5 === void 0 ? void 0 : _this$props$userInput5.isRecording);
      }
    }, {
      key: "showVideoIcon",
      get: function get() {
        var _this$props$userInput6;
        return this.props.userInputStore && this.props.userInputStore.unselectedInputType && this.props.allowVideoInput && !_state.AppUI.layout.isSafari && !((_this$props$userInput6 = this.props.userInputStore) !== null && _this$props$userInput6 !== void 0 && _this$props$userInput6.hasFinishedRecording);
      }
    }, {
      key: "showAudioIcon",
      get: function get() {
        var _this$props$userInput7;
        return !this.props.blockAudioIcon && this.props.userInputStore && (this.props.userInputStore.unselectedInputType || this.props.userInputStore.audioActiveInput) && this.props.allowAudioInput && !_state.AppUI.layout.isSafari && !((_this$props$userInput7 = this.props.userInputStore) !== null && _this$props$userInput7 !== void 0 && _this$props$userInput7.hasFinishedRecording);
      }
    }, {
      key: "showTextIcon",
      get: function get() {
        return !this.props.persistentTextInput && this.props.userInputStore && this.props.userInputStore.unselectedInputType && this.props.allowTextInput;
      }
    }, {
      key: "showTrashIcon",
      get: function get() {
        var _this$props$userInput8, _this$props$userInput9, _this$props$userInput0, _this$props$userInput1;
        return ((_this$props$userInput8 = this.props.userInputStore) === null || _this$props$userInput8 === void 0 ? void 0 : _this$props$userInput8.videoActiveInput) || ((_this$props$userInput9 = this.props.userInputStore) === null || _this$props$userInput9 === void 0 ? void 0 : _this$props$userInput9.textActiveInput) || ((_this$props$userInput0 = this.props.userInputStore) === null || _this$props$userInput0 === void 0 ? void 0 : _this$props$userInput0.hasFinishedRecording) || ((_this$props$userInput1 = this.props.userInputStore) === null || _this$props$userInput1 === void 0 ? void 0 : _this$props$userInput1.isRecording);
      }
    }, {
      key: "showSendIcon",
      get: function get() {
        return this.props.onSubmitMedia || this.props.onSubmitMessage;
      }
    }, {
      key: "showAudioPlayer",
      get: function get() {
        var _this$props$userInput10, _this$props$userInput11, _this$props$userInput12, _this$props$userInput13;
        return ((_this$props$userInput10 = this.props.userInputStore) === null || _this$props$userInput10 === void 0 ? void 0 : _this$props$userInput10.hasFinishedRecording) && ((_this$props$userInput11 = this.props.userInputStore) === null || _this$props$userInput11 === void 0 ? void 0 : _this$props$userInput11.audioActiveInput) && (((_this$props$userInput12 = this.props.userInputStore) === null || _this$props$userInput12 === void 0 ? void 0 : _this$props$userInput12.hasObjectUrl) || ((_this$props$userInput13 = this.props.userInputStore) === null || _this$props$userInput13 === void 0 ? void 0 : _this$props$userInput13.isNative));
      }
    }, {
      key: "showTextInput",
      get: function get() {
        var _this$props$userInput14;
        return ((_this$props$userInput14 = this.props.userInputStore) === null || _this$props$userInput14 === void 0 ? void 0 : _this$props$userInput14.textActiveInput) && !this.showAudioPlayer;
      }
    }, {
      key: "showSpinner",
      get: function get() {
        return this.props.userInputStore && (this.props.userInputStore.isRecording && !this.props.userInputStore.canRecord || this.props.userInputStore.nativeSoundIsLoading);
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$context;
        this.deckCardInView = (_this$context = this.context) === null || _this$context === void 0 ? void 0 : _this$context.inView;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this$context2;
        if (this.props.cardId !== prevProps.cardId) {
          this.onReset();
        } else if (!prevProps.submitted && this.props.submitted) {
          this.props.userInputStore.onUpdateMessageInput(null);
        }
        var deckCardInView = (_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : _this$context2.inView;
        if (this.deckCardInView && deckCardInView === false) {
          this.pauseOffscreen();
        }
        this.deckCardInView = deckCardInView;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props$userInput15, _this$props$userInput16;
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          showMicAccessModal: this.showMicAccessModal,
          disableSendIcon: this.disableSendIcon,
          textInputDisabled: this.textInputDisabled,
          videoDisabled: this.videoDisabled,
          audioDisabled: this.audioDisabled,
          videoRecording: this.videoRecording,
          audioRecording: this.audioRecording,
          showVideoIcon: this.showVideoIcon,
          showAudioIcon: this.showAudioIcon,
          showTextIcon: this.showTextIcon,
          showTextInput: this.showTextInput,
          showAudioPlayer: this.showAudioPlayer,
          showTrashIcon: this.showTrashIcon,
          showSendIcon: this.showSendIcon,
          onSubmit: this.onSubmit,
          onReset: this.onReset,
          onKeyUp: this.onKeyUp,
          recordingIconBorderColor: this.recordingIconBorderColor,
          recordingIconBackground: this.recordingIconBackground,
          iconWidth: this.iconWidth,
          setInputType: this.setInputType,
          onUpdateMessageInput: this.onUpdateMessageInput,
          messageInput: (_this$props$userInput15 = this.props.userInputStore) === null || _this$props$userInput15 === void 0 ? void 0 : _this$props$userInput15.messageInput,
          insertText: (_this$props$userInput16 = this.props.userInputStore) === null || _this$props$userInput16 === void 0 ? void 0 : _this$props$userInput16.insertText,
          showSpinner: this.showSpinner
        }));
      }
    }]);
  }(_react["default"].Component), _Class.contextType = _video_player_wrapper.DeckCardContext, _Class), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showMicAccessModal", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "recordingIconBorderColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "recordingIconBorderColor"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "recordingIconBackground", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "recordingIconBackground"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "iconWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "iconWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "disableSendIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "disableSendIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "textInputDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textInputDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "audioDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "audioDisabled"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "videoRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "videoRecording"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "audioRecording", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "audioRecording"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showVideoIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showVideoIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAudioIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showAudioIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showTextIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showTextIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showTrashIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showTrashIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSendIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSendIcon"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAudioPlayer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showAudioPlayer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showTextInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showTextInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _class2)) || _class;
};
UserInputWrapper.displayName = 'UserInputWrapper';
var _default = exports["default"] = UserInputWrapper;